import { render, staticRenderFns } from "./abonos.vue?vue&type=template&id=a5ff452a&"
import script from "./abonos.vue?vue&type=script&lang=js&"
export * from "./abonos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports